import { call, put } from 'redux-saga/effects'
const qs = require('qs');

export function* paginatedListSaga(action) {
    const { page, slice, token, endpoint, setAction, errorAction } = action.payload
    try {
        const query = qs.stringify({
            _limit: slice,
            _start: page * slice
        }, {
            encodeValuesOnly: true,
        });

        const response = yield call(endpoint, { query, token: token })
        yield put({ type: setAction.type, values: response, count: 0 })

    } catch (e) {
        yield put({ type: errorAction?.type, payload: e })
    }
}
